import new_player_download from "@/components/new-player/modules/new_player_download";

export default (context, file) => {
    file ? fetch(file).then((data) => {
        data.blob()
            .then(async (blob) => {
                await context.$store.dispatch('cache_videos/setCacheVideos', {
                    info: { blob: blob, url: file  }
                })
                new_player_download(context)
            })
            .catch(e => {
                console.error(e)
            })
    }) : false



}